import { apiClient } from './client'
import type { AdminMetrics, PaginatedUsersResponse, PaginatedProjectsResponse } from '../types'

export async function listUsers(page = 1, limit = 20): Promise<PaginatedUsersResponse> {
  const { data } = await apiClient.get<PaginatedUsersResponse>('/api/v1/admin/users', {
    params: { page, limit },
  })
  return data
}

export async function listProjects(page = 1, limit = 20): Promise<PaginatedProjectsResponse> {
  const { data } = await apiClient.get<PaginatedProjectsResponse>('/api/v1/admin/projects', {
    params: { page, limit },
  })
  return data
}

export async function getMetrics(period: '7d' | '30d' | '90d' = '30d'): Promise<AdminMetrics> {
  const { data } = await apiClient.get<AdminMetrics>('/api/v1/admin/metrics', {
    params: { period },
  })
  return data
}
